import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CanalCommunication } from 'src/app/shared/models/canalCommunication';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CanalCommunicationModalAjoutComponent } from '../modal/canalCommunication-modal-ajout/canalCommunication-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { CanalCommunicationModalDetailComponent } from '../modal/canalCommunication-modal-detail/canalCommunication-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-canalCommunication',
	templateUrl: './list-canalCommunication.component.html',
	styleUrls: ['./list-canalCommunication.component.scss']
})
export class ListCanalCommunicationComponent implements OnInit {
	canalCommunication: CanalCommunication[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	canalCommunicationCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editCanalCommunicationModalRef: BsModalRef;
	addCanalCommunicationModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getCanalCommunication();
		this.isAddable = true;
	}

	getCanalCommunication(): void {
		this.isListingLoading = true;
		this.facade.canalCommunicationService.getAllCanalCommunication().subscribe({
			next: (val) => {
				this.canalCommunication = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.canalCommunication.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.canalCommunication = [];
			}
		});
	}

	selectCanalCommunication(canalCommunication: CanalCommunication): void {
		const link = ['/canalCommunication', canalCommunication.id];
		this.router.navigate(link);
	}

	importCanalCommunication(event: any): void {
		this.canalCommunicationCsvFile = event.target.files[0];

		this.facade.canalCommunicationService
			.importCanalCommunication(this.canalCommunicationCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} canalCommunication ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getCanalCommunication();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addCanalCommunicationModalRef = this.modalService.show(
			CanalCommunicationModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addCanalCommunicationModalRef.onHide.subscribe((reason: string | any) => {
			this.getCanalCommunication();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(canalCommunication: CanalCommunication) {
		const initialState = {
			canalCommunication: canalCommunication
		};
		this.editCanalCommunicationModalRef = this.modalService.show(
			CanalCommunicationModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editCanalCommunicationModalRef.onHide.subscribe((reason: string | any) => {
			this.getCanalCommunication();
		});
	}
}
